import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../../../../../../../context';

// Filter for the "Is Code Bundle" column: All / Yes / No.
const BundleFilterSelector = () => {
    const dispatch = useDispatch();
    const codeIsBundleFilter = useSelector((state) => state.daylight.codeIsBundleFilter);

    const value =
        codeIsBundleFilter === null || codeIsBundleFilter === undefined
            ? ''
            : String(codeIsBundleFilter);

    const onChange = (e) => {
        const v = e.target.value;
        dispatch(actions.daylight.setCodeIsBundleFilter(v === '' ? null : v === 'true'));
    };

    return (
        <th scope="col" className="col col-medium">
            <select className="p-1 rounded w-100" value={value} onChange={onChange}>
                <option value="">All</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
            </select>
        </th>
    );
};

export default BundleFilterSelector;
